import React from "react";

import { Button } from "clearsense-ui/components";

const Footer = ({
  connectionType,
  isConnectionSetup,
  setIsConnectionSetup,
  setConnectionType,
  isPathReady,
  close,
  submit,
}) =>
  connectionType === "general" ? (
    <div className="flex justify-end w-full space-x-4 ">
      <Button
        label="Cancel"
        style="secondary"
        onClick={close}
        data-cy="cancel-connection-button"
      />
      <Button
        label="Next Step"
        disabled={!isConnectionSetup}
        onClick={() => setConnectionType("connection")}
        data-cy="next-step-button"
      />
    </div>
  ) : (
    <div className="flex justify-between w-full">
      <Button
        style="text"
        label="Previous step"
        className="whitespace-nowrap"
        onClick={() => {
          setConnectionType("general");
          setIsConnectionSetup(false);
        }}
      />
      <div className="flex justify-end w-full space-x-4 ">
        <Button label="Cancel" style="secondary" onClick={close} />
        <Button
          label="Setup Connection"
          onClick={submit}
          disabled={!isPathReady}
          data-cy={"submit-connection-button"}
        />
      </div>
    </div>
  );

export default Footer;
